/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import moment from 'moment';
import { PlayerWelcomePopUp, AdjustRatingPopUp, OrganizerWelcomePopUp, UtrRangePopup, PbrRangePopup } from '../../../components/PopUps';
import HomeHeader from '../../../components/Home/HomeHeader';
import Notifications from '../../../components/Home/Notifications';
import CollegeRecrutingWelomePopup from '../../../components/Welcome/CollegeRecrutingWelomePopup';
import GlobalRankingsV2 from '../../../components/RankingTables/GlobalRankingsV2';
import EventsRegistered from '../DashboardContent/EventsRegistered';
import RecentResults from '../DashboardContent/RecentResults';
import PendingResults from '../DashboardContent/PendingResults';
import Clubs from '../DashboardContent/Clubs';
import PaidHitClubs from './PaidHitClubs';
import PaidHits from './PaidHits';
import EventsNearMe from './EventsNearMe';
import LocalPlayers from './LocalPlayers';
import CollegesNearMe from './CollegesNearMe';
import HighSchoolsNearMe from './HighSchoolsNearMe';
import PlayerCreatedPlaysNearMe from './PlayerCreatedPlaysNearMe';
import requestLocation from '../../../components/hocs/RequestLocation';
import config from '../../../../config';
import { getDashboardLeagueTeams } from '../../../actions/leagues-actions';
import FlexLeagueMatchCards from '../DashboardContent/FlexLeagueMatchCards';

import { setRatingChoice, getRatingDetails } from '../../../utils';
import LeagueTeams from './LeaguesTeams';
import NCSAPopup from '../../../components/PopUps/WelcomePopUps/NCSAPopup';
import PowerPerksBannerCarousel from '../../../components/Banners/PowerPerksBanner/PowerPerksBannerCarousel';
import { getPrismicDoc } from '../../../actions/prismic-actions';
import { gtag } from '../../../components/Analytics/gtag';

import styles from '../dashboardPage.scss';
import SportType from '../../NuoV2/SportType';
import { updateSportTypes } from '../../../actions/search-actions';
import AdWrapper from '../../../components/Ads/AdWrapper';
import { AdTypes } from '../../../utils/types';
import { useAdDynamicConfig } from '../../../components/hooks/useAdDynamicConfig';
import { useStatsig } from '../../../components/hooks/useStatsig';
import useIsMobile from '../../../components/hooks/useIsMobile';
import MyManagedEvents from '../DashboardContent/MyManagedEvents';
import GlobalPrivilegesBanner from '../../../components/Banners/GlobalPrivileges';
import FableticsBanner from '../../../components/Banners/Fabletics';
import useFabletics from '../../../components/hooks/useFabletics';
import { PowerFunnelSurfaces } from '../../../components/Analytics/constants';
import { updatePreRegNotificationCanDisplayStatus } from '../../../actions/notification-actions';

function DashboardContentV2(props) {
    const { dashboard, componentConfig, search, onboarding, profile, coreUI } = props;
    const { dashboardTeams, isDashboardTeamsLoaded, dashboardErrorMessage, isLoadingDashboardTeams } = useSelector((state) => state.leagues);
    const prismic = useSelector(({ prismic }) => prismic);
    const dispatch = useDispatch();
    const { checkGate, initializeStatsigUser, featureGates } = useStatsig();
    const { showAds, homeConfig } = useAdDynamicConfig();
    const { isMobileWidth, isTabletWidth } = useIsMobile();

    const auth = useSelector((state) => state.auth);
    const { user, feedPreferences, feedPreferencesLoadedAtLeastOnce, isFeedPreferencesLoading } = auth;
    const compConfig = componentConfig.dashboard;
    const playerWelcomePopUp = compConfig?.modals?.find(m => m.type === 'claimed_player_welcome_popup');
    const findCollegePopup = compConfig?.modals?.find(m => m.type === 'find_colleges_welcome_popup');
    const tosNotification = compConfig?.modals?.find(m => m.type === 'tos_updated_notification');
    const { isPowered, isClubOrganizer } = user || {};
    const showTwoDecimals = true;
    const rating = getRatingDetails(setRatingChoice({ player: profile?.data }), isPowered, showTwoDecimals, false, false);
    const isPBRPlayer = rating.showPBRRating;
    const isNcsaGateEnabled = checkGate(featureGates.NCSA);
    const displayGlobalPrivilegesFeature = checkGate(featureGates.POWER_UPGRADE_MODAL_V4);
    const { enabled: isFableticsEnabled } = useFabletics();
    const ncsaCount = parseInt(localStorage.getItem(`homepage-ncsa-${user?.id}`) || 0);
    const tennisHeader = 'Team Tennis';
    const pickleballHeader = 'Team Pickleball';

    let currentAge = 0;
    if (user.birthdate) {
        currentAge = moment().diff(user.birthdate, 'years');
    }

    const [showPlayerWelcomeScreen, setShowPlayerWelcomeScreen] = useState(true);
    const [showOrganizerWelcomeScreen, setShowOrganizerWelcomeScreen] = useState(false);
    const [showCollegeRecruitingWelcomePopup, setShowCollegeRecruitingWelcomePopup] = useState(true);
    const [showTOSUpdatedNotification, setShowTOSUpdatedNotification] = useState(true);
    const [showAdjustRatingPopUp, setShowAdjustRatingPopUp] = useState(false);
    const [showUtrRangePopup, setShowUtrRangePopup] = useState(false);
    const [showPbrRangePopup, setShowPbrRangePopup] = useState(false);
    const [showNCSAPopup, setShowNCSAPopup] = useState(false);

    useEffect(() => {
        dispatch(updateSportTypes(user ? { tennis: feedPreferences?.showTennisContent, pickleball: feedPreferences?.showPickleballContent } : { tennis: true, pickleball: true }));

        initializeStatsigUser();

        props.getMemberDashboard(user);

        const shouldFetchFeedPreferences = !feedPreferences && !isFeedPreferencesLoading;

        if (user?.claimedPlayer) {
            props.getPlayerProfile(user.claimedPlayer?.playerId);
        }

        if (shouldFetchFeedPreferences && props.getFeedPreferences) {
            props.getFeedPreferences();
        }

        if (!isDashboardTeamsLoaded && !isLoadingDashboardTeams && !dashboardErrorMessage) {
            dispatch(getDashboardLeagueTeams());
        }

        if (!prismic.power_perks) {
            dispatch(getPrismicDoc('power_perks', 'power_perks'));
        }
    }, []);

    useEffect(() => {
        const shouldFetchFeedPreferences = !feedPreferences && !isFeedPreferencesLoading;
        if (shouldFetchFeedPreferences && props.getFeedPreferences) {
            props.getFeedPreferences();
        }
    }, [user]);

    useEffect(() => {
        if (!props.dashboard.isLoading) {
            const { state } = props.history.location;
            props.history.replace({
                state: null,
            });
            if (state?.showOrganizerWelcomeScreen) {
                setShowOrganizerWelcomeScreen(state.showOrganizerWelcomeScreen);
            }
            setShowNCSAPopup(isNcsaGateEnabled && currentAge >= 13 && currentAge <= 18 && ncsaCount < 3 && !user.isRegisteredWithNcsa);
        }
    }, [props.dashboard.isLoading]);

    useEffect(() => {
        if (showNCSAPopup) {
            // segment track call
            const path = '/home';
            const properties = {
                path,
                url: path,
                title: 'Home Page NCSA Popup',
            };
            gtag('view', {
                category: 'NCSA',
                context: 'Show home page ncsa popup',
            });
            // mapped to GA4
            if (window?.analytics) {
                window?.analytics?.page('Show home page ncsa popup', 'Home', properties);
            }
        }
    }, [showNCSAPopup]);

    useEffect(() => {
        if (tosNotification && !dashboard.isLoading) {
            props.componentConfigActionPerformed(tosNotification.type, tosNotification.actions.confirmed.event);
        }
    }, [dashboard, tosNotification]);

    const filterPreferences = useMemo(() => {
        if (feedPreferences) {
            const updatedFilters = {
                utrMin: feedPreferences.utrMin,
                utrMax: feedPreferences.utrMax,
                distance: `${feedPreferences.distance || 50}mi`,
                gender: !feedPreferences.gender || feedPreferences.gender === 'all' ? '' : feedPreferences.gender,
                sportTypes: {
                    tennis: auth?.user ? !!feedPreferences?.showTennisContent : true,
                    pickleball: auth?.user ? !!feedPreferences?.showPickleballContent : true,
                },
            };
            if (feedPreferences.gameLocation === 'gps' && search.geocoded) {
                updatedFilters.location = search.geocoded.location;
                updatedFilters.lat = search.geocoded.lat;
                updatedFilters.lng = search.geocoded.lng;
            } else if ((!search.geocoded || feedPreferences.gameLocation === 'profile') && user.location) {
                updatedFilters.location = user.location.display;
                updatedFilters.lat = user.location.latLng[0];
                updatedFilters.lng = user.location.latLng[1];
            } else {
                updatedFilters.location = 'Palo Alto, CA, USA';
                updatedFilters.lat = '37.4418834';
                updatedFilters.lng = '-122.1430195';
            }

            return updatedFilters;
        }

        if (feedPreferencesLoadedAtLeastOnce) {
            return {
                location: 'Palo Alto, CA, USA',
                lat: '37.4418834',
                lng: '-122.1430195',
                distance: '50mi',
                utrMin: 1,
                utrMax: 16,
                gender: '',
            };
        }

        return null;
    }, [feedPreferences, feedPreferencesLoadedAtLeastOnce, user.location, search.geocoded]);

    useEffect(() => {
        setShowUtrRangePopup(onboarding.showRangePopup);
    }, [onboarding.showRangePopup]);

    useEffect(() => {
        setShowPbrRangePopup(onboarding.showPbrRangePopup);
    }, [onboarding.showPbrRangePopup]);

    const isFeedPreferencesModalHidden = localStorage.getItem(auth?.user?.email);

    useEffect(() => {
        const popUpsToCheck = {
            shouldShowCollegeRecruitingPopup: findCollegePopup && showCollegeRecruitingWelcomePopup,
            showOrganizerWelcomeScreen,
            showPlayerWelcomePopup: playerWelcomePopUp && showPlayerWelcomeScreen,
            showAdjustRatingPopUp,
            showNCSAPopup,
            showPbrRangePopup,
            showUtrRangePopup,
            showTermsUpdated: tosNotification && showTOSUpdatedNotification,
            showFeedPreferencesModal: !isFeedPreferencesModalHidden,
            isDashBoardLoading: dashboard.isLoading,
        };
        // all of the values in object above should be false to show pre-registration notification
        const canShowPreRegNotification = Object.values(popUpsToCheck)?.every(value => !value);
        dispatch(updatePreRegNotificationCanDisplayStatus(canShowPreRegNotification));
    }, [showUtrRangePopup, showNCSAPopup, showAdjustRatingPopUp, showPbrRangePopup, showPlayerWelcomeScreen, showOrganizerWelcomeScreen, showCollegeRecruitingWelcomePopup, findCollegePopup, playerWelcomePopUp, isFeedPreferencesModalHidden, tosNotification, showTOSUpdatedNotification, dashboard.isLoading]);

    const closeCollegeRecruitingWelcomePopup = () => {
        setShowCollegeRecruitingWelcomePopup(false);

        if (findCollegePopup) {
            props.componentConfigActionPerformed(findCollegePopup.type, findCollegePopup.actions.confirmed.event);
        }
    };

    const handleCollegeRecruitingPopupNextAction = (event, action) => {
        if (action === 'next' && auth.user.claimedPlayer) {
            props.history.push(`/profiles/${auth.user.claimedPlayer.playerId}?t=6`);
        }

        closeCollegeRecruitingWelcomePopup();
    };

    const toggleAdjustRatingPopUp = () => {
        setShowAdjustRatingPopUp(!showAdjustRatingPopUp);
    };

    const hideTos = () => {
        setShowTOSUpdatedNotification(false);
    };

    const toExplore = (type, filters) => {
        if (type === 'events') {
            props.clearFilters('date', false);
        }
        props.applySearchFilters({
            type,
            ...filters,
        }, true);
        props.history.push(`/search?type=${type}`);
    };

    const confirmNCSAPopup = () => {
        // segment track call - mapped to GA4
        if (window?.analytics) {
            window?.analytics?.track('NCSA HomePage Popup Yes Click', {
                userId: user.id,
                flow: '28157',
            });
        }
        localStorage.setItem(`homepage-ncsa-${user.id}`, ncsaCount + 1);
        props.history.push('/ncsa/register?eventType=home-page-popup');
    };

    const dismissNCSAPopup = () => {
        localStorage.setItem(`homepage-ncsa-${user.id}`, ncsaCount + 1);
        setShowNCSAPopup(false);
    };

    const dismissUtrRangePopup = () => {
        props.showOnboardingRangePopup(false, 'utrRange'); // clear onboarding reducer state
        setShowUtrRangePopup(false);
    };

    const dismissPbrRangePopup = () => {
        props.showOnboardingRangePopup(false, 'pbrRange'); // clear onboarding reducer state
        setShowPbrRangePopup(false);
    };

    return (
        <div className={`${styles.dashBoard}`}>
            {dashboard.isLoading && !filterPreferences && (
                <div />
            )}
            {!dashboard.isLoading && !!filterPreferences && (
                <>
                    <SportType isFeedPreferenceModal={true} auth={auth} />
                    <div className={`${styles.content}`}>
                        {tosNotification && showTOSUpdatedNotification && (
                            <div className="container">
                                <div className={`${styles.section} sub-header admin-splash bg-teal`}>
                                    <div className="row tos mt16">
                                        <div className="col-1" />
                                        <div className={`col d-flex align-items-center justify-content-center`}>
                                            <span data-testid="dashboard.tos-notification.message">We have recently updated our <Link to={{ pathname: `${config.marketingAppHost}/tos` }} target="_blank" data-testid="dashboard.tos-notification.tos-link">Terms of Service</Link> and <Link to={{ pathname: `${config.marketingAppHost}/privacy` }} target="_blank" data-testid="dashboard.tos-notification.privacy-link">Privacy Policy</Link>.</span>
                                        </div>
                                        <div className="col-1 d-flex close">
                                            <a onClick={hideTos} data-testid="dashboard.tos-notification.close-btn"> X</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {(dashboard?.newDashboard?.homedashNotifications) && (
                            <Notifications homedashNotifications={dashboard.newDashboard.homedashNotifications} data-testid="dashboard.notifications" />
                        )}
                        {dashboard?.newDashboard?.exploreItems && (
                            <HomeHeader
                                exploreItems={dashboard.newDashboard.exploreItems}
                                applySearchFilters={props.applySearchFilters}
                                clearFilters={props.clearFilters}
                                history={props.history}
                                auth={auth}
                                profile={props.profile?.data}
                            />
                        )}
                        {displayGlobalPrivilegesFeature && (
                            <div className="container">
                                {isFableticsEnabled
                                    ? <FableticsBanner surface={PowerFunnelSurfaces.HOME} />
                                    : <GlobalPrivilegesBanner surface={PowerFunnelSurfaces.HOME} />}
                            </div>
                        )}
                        <div className="container">
                            {showAds && homeConfig.showLeaderboard && (
                                <div className="d-flex jcc mt40">
                                    <AdWrapper type={AdTypes.LEADERBOARD_ONE} data-testid="dashboard.ad.leaderboard" />
                                </div>
                            )}
                            {dashboard?.newDashboard && !!dashboardTeams?.tennis?.length && !isPBRPlayer && (
                                <LeagueTeams
                                    teams={dashboardTeams.tennis}
                                    title={tennisHeader}
                                    data-testid="dashboard.league-teams.tennis"
                                />
                            )}
                            {dashboard?.newDashboard && !!dashboardTeams?.pickleball?.length && !isPBRPlayer && (
                                <LeagueTeams
                                    teams={dashboardTeams?.pickleball}
                                    title={pickleballHeader}
                                    data-testid="dashboard.league-teams.pickleball"
                                />
                            )}
                            {dashboard?.newDashboard?.flexLeagueMatchCards && (
                                <div className="mt80 mb40">
                                    <FlexLeagueMatchCards
                                        flexLeagueMatchCards={dashboard.newDashboard.flexLeagueMatchCards}
                                        auth={auth}
                                        redirectUrl={`/post-score-select`}
                                    />
                                </div>
                            )}
                            {isClubOrganizer && !!dashboard?.newDashboard?.eventsOrganizing?.length && (
                                <MyManagedEvents
                                    eventsOrganizing={dashboard?.newDashboard?.eventsOrganizing}
                                    auth={auth}
                                    title={'My Managed Events'}
                                    showTennisContent={feedPreferences?.showTennisContent}
                                    showPickleballContent={feedPreferences?.showPickleballContent}
                                />
                            )}
                            {dashboard?.newDashboard?.eventsRegistered && (
                                <EventsRegistered
                                    eventsRegistered={dashboard?.newDashboard?.eventsRegistered}
                                    history={props.history}
                                    auth={auth}
                                    title={'My Events'}
                                    showTennisContent={feedPreferences?.showTennisContent}
                                    showPickleballContent={feedPreferences?.showPickleballContent}
                                />
                            )}

                            {showAds && (
                                <div className={`${styles.rectangleAdContainer}`}>
                                    {homeConfig?.showRectangle && !isMobileWidth && !isTabletWidth && (
                                        <>
                                            <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="dashboard.ad.rectangle-1" />
                                            <AdWrapper type={AdTypes.RECTANGLE_TWO} data-testid="dashboard.ad.rectangle-2" />
                                            <AdWrapper type={AdTypes.RECTANGLE_THREE} data-testid="dashboard.ad.rectangle-3" />
                                        </>
                                    )}
                                    {homeConfig?.showRectangle && !isMobileWidth && isTabletWidth && (
                                        <>
                                            <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="dashboard.ad.tablet-rectangle-1" />
                                            <AdWrapper type={AdTypes.RECTANGLE_TWO} data-testid="dashboard.ad.tablet-rectangle-2" />
                                        </>
                                    )}
                                    {homeConfig?.showRectangle && isMobileWidth && !isTabletWidth && (
                                        <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="dashboard.ad.mobile-rectangle-1" />
                                    )}
                                </div>
                            )}
                            {dashboard?.newDashboard?.clubs && (
                                dashboard?.newDashboard?.clubs?.length > 0 || auth?.user?.isPlayer) && (
                                    <Clubs
                                        clubs={dashboard.newDashboard.clubs}
                                        auth={auth}
                                        search={search}
                                        history={props.history}
                                        clubEvents={dashboard.newDashboard.eventsAtMemberClubs}
                                    />
                                )}
                            <div className="mt80 mb40">
                                <EventsNearMe
                                    filterPreferences={filterPreferences}
                                    isPBRPlayer={isPBRPlayer}
                                />
                            </div>
                            {showAds && homeConfig?.showWideLeaderboard && (
                                <div className="mt80 d-flex jcc mb40">
                                    <AdWrapper type={AdTypes.WIDE_LEADERBOARD_ONE} data-testid="dashboard.ad.wide-leaderboard" />
                                </div>
                            )}
                            {!dashboard?.newDashboard?.eventsRegistered?.length && (
                                <PowerPerksBannerCarousel />
                            )}
                            {dashboard?.newDashboard?.pendingResults && (
                                <div className="mt80 mb40">
                                    <PendingResults
                                        pendingResults={dashboard.newDashboard.pendingResults}
                                        auth={auth}
                                    />
                                </div>
                            )}
                        </div>
                        {dashboard?.newDashboard?.recentResults && !!dashboard?.newDashboard?.recentResults?.length && (
                            <div className={styles.recentResultsWrapper}>
                                <div className="container">
                                    <RecentResults
                                        recentResults={dashboard.newDashboard.recentResults}
                                        history={props.history}
                                        auth={auth}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="container">
                            {!isPBRPlayer && feedPreferences?.showTennisContent && (
                                <>
                                    <div className="mt80 mb40">
                                        <PlayerCreatedPlaysNearMe filterPreferences={filterPreferences} />
                                    </div>
                                    <div className="mt80 mb40">
                                        <PaidHits filterPreferences={filterPreferences} />
                                    </div>
                                    <div className="mt80 mb40">
                                        <PaidHitClubs filterPreferences={filterPreferences} coreUI={coreUI} />
                                    </div>
                                </>
                            )}
                            <div className="mt80 mb40">
                                <CollegesNearMe
                                    filterPreferences={filterPreferences}
                                    auth={auth}
                                />
                            </div>
                            <div className="mt80 mb40">
                                <HighSchoolsNearMe
                                    filterPreferences={filterPreferences}
                                    auth={auth}
                                />
                            </div>
                            {feedPreferences?.showTennisContent && (
                                <div className="mt80 mb40">
                                    <LocalPlayers filterPreferences={filterPreferences} />
                                </div>
                            )}
                            <GlobalRankingsV2
                                auth={auth}
                                displayCount={10}
                                data-testid="dashboard.global-rankings"
                            />
                        </div>
                    </div>
                </>
            )}
            {showAds && homeConfig?.showSticky && (
                <AdWrapper type={AdTypes.STICKY} data-testid="dashboard.ad.sticky" />
            )}
            {showNCSAPopup ? (
                <NCSAPopup
                    onConfirm={confirmNCSAPopup}
                    onCloseClick={dismissNCSAPopup}
                />
            ) : (
                <>
                    {showUtrRangePopup && (
                        <UtrRangePopup
                            rating={rating}
                            onCloseClick={dismissUtrRangePopup}
                        />
                    )}
                    {showPbrRangePopup && (
                        <PbrRangePopup
                            rating={rating}
                            onCloseClick={dismissPbrRangePopup}
                        />
                    )}
                </>
            )}
            {(!showUtrRangePopup && !showNCSAPopup) && (
                <>
                    {showAdjustRatingPopUp && (
                        <AdjustRatingPopUp
                            onCloseClick={toggleAdjustRatingPopUp}
                            auth={auth}
                        />
                    )}
                    {playerWelcomePopUp && showPlayerWelcomeScreen && auth.user.claimedPlayer && dashboard?.member && (
                        <PlayerWelcomePopUp
                            onCloseClick={() => {
                                setShowPlayerWelcomeScreen(false);
                                props.componentConfigActionPerformed(playerWelcomePopUp.type, playerWelcomePopUp.actions.dismissed.event);
                            }}
                            onCtaClick={() => {
                                setShowPlayerWelcomeScreen(false);
                                props.componentConfigActionPerformed(playerWelcomePopUp.type, playerWelcomePopUp.actions.confirmed.event);
                            }}
                            auth={auth}
                            dashboard={dashboard}
                            toExplore={toExplore}
                            fetchCurrentLocation={props.fetchCurrentLocation}
                        />
                    )}
                    {showOrganizerWelcomeScreen && (
                        <OrganizerWelcomePopUp
                            onCloseClick={() => setShowOrganizerWelcomeScreen(false)}
                            memberName={dashboard.member.firstName}
                        />
                    )}
                    {(findCollegePopup && showCollegeRecruitingWelcomePopup && auth.user.claimedPlayer?.collegeRecruiting) && (
                        <CollegeRecrutingWelomePopup
                            onCloseClick={closeCollegeRecruitingWelcomePopup}
                            handleClick={handleCollegeRecruitingPopupNextAction}
                        />
                    )}
                </>
            )}
        </div>
    );
}
DashboardContentV2.propTypes = {
    dashboard: PropTypes.instanceOf(Object).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    getPlayerProfile: PropTypes.func.isRequired,
    getMemberDashboard: PropTypes.func.isRequired,
};

export default requestLocation(DashboardContentV2);
